import {
  getFormData,
  resetFormErrors,
  showFormErrors
} from '../../utils/form';
import * as notification from '../../components/notifications';
import * as rc from "../../utils/rc";

let deleteCompanyProfileModal;
let confirmDeleteCompanyProfileBtn;
let deleteCompanyProfileForm;

const initPage = () => {
  deleteCompanyProfileModal = $("#modal-delete-company-profile");

  if (!deleteCompanyProfileModal) {
    return;
  }
  confirmDeleteCompanyProfileBtn = $(".btn-modal-confirm", deleteCompanyProfileModal);
  deleteCompanyProfileForm = $("#delete-company-profile-form", deleteCompanyProfileModal)

  deleteCompanyProfileModal.submit(function() {
    confirmDeleteCompanyProfile();
    return false;
  })

  $("#delete-company-profile-btn").click(() => {
    deleteCompanyProfileModal.modal('show');
  });

  confirmDeleteCompanyProfileBtn.click(confirmDeleteCompanyProfile);
};

const confirmDeleteCompanyProfile = async () => {
  confirmDeleteCompanyProfileBtn.loading();

  try {
    const response = await axios.delete("/api/employers/current", {data: getFormData(deleteCompanyProfileForm)});
    resetFormErrors(deleteCompanyProfileForm);

    notification.success(response.data.message);

    const redirectUrl = response.data.redirect_url || rc.getEmployerAccountJobPageUrl();

    setTimeout(() => {
      window.location.replace(redirectUrl);
    }, 1000)
  } catch (e) {
    $("#password", deleteCompanyProfileForm).val('');
    confirmDeleteCompanyProfileBtn.loading(false);
    showFormErrors(deleteCompanyProfileForm, e.response);

    if (e.response.data.short_message) {
      deleteCompanyProfileModal.modal('hide');
    }
  }
};

$(initPage);
